module.exports = __webpack_public_path__ + "static/castelo-escola-9ca5cbcc9ab8f9a712b394474e4a6a3d.png";